import {
  infiniteQueryOptions,
  queryOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  tournamentApplyList,
  tournamentJoinedList,
  tournamentCancelList,
  alarmList,
  readAllNotifications,
  getNewAlarm,
  getSettingTournamentDetails,
  getSettingTournamentApplyDetail,
} from "../v1/setting.service";

export const useSettingTournamentDetail = (id: string | number) =>
  queryOptions({
    queryKey: ["setting-tournament-detail", id],
    queryFn: () => getSettingTournamentDetails(id),
    retry: 1,
  });
export const useSettingTournamentApplyDetail = (
  id: string | number,
  applyId: string | number,
) =>
  queryOptions({
    queryKey: ["setting-tournament-apply-detail", id, applyId],
    queryFn: () => getSettingTournamentApplyDetail(id, applyId),
    retry: 1,
  });

export const useTournamentApplyList = () =>
  queryOptions({
    queryKey: ["tournament-apply-list"],
    queryFn: () => tournamentApplyList(),
    retry: 1,
  });

const TOURNAMENT_APPLY_LIST_PAGE_SIZE = 20;

// 내 대회 접수/결제 내역 무한 스크롤 (onlyJoined=true 면 참가완료만)
export const useTournamentApplyListInfinite = (onlyJoined = false) =>
  infiniteQueryOptions({
    queryKey: ["tournament-apply-list", { onlyJoined }],
    queryFn: ({ pageParam }) =>
      tournamentApplyList({
        onlyJoined: onlyJoined || undefined,
        page: pageParam,
        pageSize: TOURNAMENT_APPLY_LIST_PAGE_SIZE,
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const paging = lastPage.data?.paging;
      if (!paging) return undefined;
      return paging.page < paging.totalPages ? paging.page + 1 : undefined;
    },
    retry: 1,
  });

export const useTournamentJoinedList = () =>
  queryOptions({
    queryKey: ["tournament-joined-list"],
    queryFn: () => tournamentJoinedList(),
    retry: 1,
  });

const TOURNAMENT_CANCEL_LIST_PAGE_SIZE = 20;

export const useTournamentCancelListInfinite = () =>
  infiniteQueryOptions({
    queryKey: ["tournament-cancel-list"],
    queryFn: ({ pageParam }) =>
      tournamentCancelList({
        page: pageParam,
        pageSize: TOURNAMENT_CANCEL_LIST_PAGE_SIZE,
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const paging = lastPage.data?.paging;
      if (!paging) return undefined;
      return paging.page < paging.totalPages ? paging.page + 1 : undefined;
    },
    retry: 1,
  });

// 알림 목록
export const useAlarmApplyList = () =>
  queryOptions({
    queryKey: ["notification-list"],
    queryFn: () => alarmList(),
    retry: 1,
  });

// // 모두 읽음 처리
export const useReadAllNotifications = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: readAllNotifications,
    onSuccess: () => {
      // 목록 캐시 무효화(invalidate) → 다음에 이 쿼리가 활성화될 때 최신 서버값으로 재요청
      qc.invalidateQueries({ queryKey: ["notification-list"] });
    },
  });
};

// 새 알림 존재 여부
export const useNewAlarm = () =>
  queryOptions({
    queryKey: ["new-alarm"],
    queryFn: () => getNewAlarm(),
    retry: 1,
  });
